import Modal from "react-modal";

export const NewItemsValidationModal = ({ actions, ctx, uiState }) => {
  const { onClose } = actions || {};
  const { invalidItems } = ctx || {};
  const { isOpen } = uiState || {};

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      style={{
        overlay: {
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 20000,
        },
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          padding: "2rem",
          borderRadius: "8px",
          width: "500px",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        },
      }}
      contentLabel="Itens pendentes"
    >
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
        <hgroup>
          <h2 style={{ margin: 0, fontSize: "1.2rem", fontFamily: "Lato, sans-serif" }}>
            <strong>Ação necessária</strong>
          </h2>
          <p style={{ color: "rgb(100, 116, 139)", fontSize: "0.875rem", margin: "4px 0 0" }}>
            Os produtos abaixo foram adicionados mas ainda não possuem compra final informada.
            Edite-os antes de salvar, ou eles não serão considerados como um item válido neste pedido.
          </p>
        </hgroup>
        <button
          onClick={onClose}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: "1.2rem",
            color: "#626772",
          }}
        >
          ✕
        </button>
      </div>

      {/* Lista de itens inválidos */}
      <div style={{
        border: "1px solid hsl(214.3 31.8% 91.4%)",
        borderRadius: "6px",
        overflow: "hidden",
      }}>
        {invalidItems?.map(item => (
          <div
            key={item.productId}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "12px 16px",
              borderBottom: "1px solid #f0f2f4",
              backgroundColor: "#fff",
            }}
          >
            <div style={{
              width: "36px",
              height: "36px",
              borderRadius: "8px",
              backgroundColor: "#FFF5EC",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                  stroke="#e75d0d"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div style={{ flex: 1 }}>
              <p style={{
                margin: 0,
                fontSize: "14px",
                fontWeight: "700",
                fontFamily: "Lato, sans-serif",
                color: "#2c2c2a",
              }}>
                {item.productName}
              </p>
              <p style={{
                margin: 0,
                fontSize: "12px",
                fontFamily: "Lato, sans-serif",
                color: "#888780",
              }}>
                SKU {item.sku} · Compra final não informada
              </p>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};